import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_CON023_Request,
  IAPI_CON023_Response,
} from "../../../type/apiType";

// 契約解除（中小企業退職金共済契約締結）内容入力表示
const httpAPI_CON023 = async (
  param: IAPI_CON023_Request
): Promise<IAPI_CON023_Response> => {
  let res = await http.post(ApiUrl.API_CON023, {
    ...param,
  });
  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON023, httpAPI_APP016 };
